module.exports = __webpack_public_path__ + "img/bluedownarrow.a53f5a63.svg";